import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';

/** Contract of the page and the worker for the API's answer to the app's version. */
export const apiVersionContract = defineChannelContract<{
  requests: Record<never, never>;
  events: {
    /** The API refused a request of this app version (HTTP 498): the app must be reloaded. */
    [DomainMessagesTypes.apiVersionMismatch]: undefined;
  };
}>('apiVersionChannel');
